module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-0f5196.19acf285.png";